<template>
	<div class="table-responsive">
         <table class="table  table-condensed">
			<thead>
                <tr>
                    <th style="width:22%" scope="col">Collected Income</th>
                    <th v-bind:class="{'active-month': currentMonth == 1}" style="width:6%;text-align:center" scope="col">Jan</th>
                    <th v-bind:class="{'active-month': currentMonth == 2}" style="width:6%;text-align:center" scope="col">Feb</th>
                    <th v-bind:class="{'active-month': currentMonth == 3}" style="width:6%;text-align:center" scope="col">Mar</th>
                    <th v-bind:class="{'active-month': currentMonth == 4}" style="width:6%;text-align:center" scope="col">Apr</th>
                    <th v-bind:class="{'active-month': currentMonth == 5}" style="width:6%;text-align:center" scope="col">May</th>
                    <th v-bind:class="{'active-month': currentMonth == 6}" style="width:6%;text-align:center" scope="col">Jun</th>
                    <th v-bind:class="{'active-month': currentMonth == 7}" style="width:6%;text-align:center" scope="col">Jul</th>
                    <th v-bind:class="{'active-month': currentMonth == 8}" style="width:6%;text-align:center" scope="col">Aug</th>
                    <th v-bind:class="{'active-month': currentMonth == 9}" style="width:6%;text-align:center" scope="col">Sep</th>
                    <th v-bind:class="{'active-month': currentMonth == 10}" style="width:6%;text-align:center" scope="col">Oct</th>
                    <th v-bind:class="{'active-month': currentMonth == 11}" style="width:6%;text-align:center" scope="col">Nov</th>
                    <th v-bind:class="{'active-month': currentMonth == 12}" style="width:6%;text-align:center" scope="col">Dec</th>
                    <th style="width:6%;text-align:center" scope="col">Total</th>
                </tr>
			</thead>
			<tbody>
				<tr class="clickable-row" v-for="propertyFee, key, index in getProperties">
					<td class="clickable-column test" scope="row"> 
						<strong> 
							<div v-if="propertyFee.isBuilding">
                                <a style="color: #212122;font-weight: normal;" @click.prevent="openBuilding(propertyFee)">{{propertyFee.propertyName}}</a>
                            </div>
							<div v-else>
                                <router-link style="color: #212122;font-weight: normal;" data-toggle="tooltip"
            data-placement="top" :title="propertyFee.ownerName" :to="{name:'userstatement', params: { propertyId:propertyFee.propertyId, buildingId:buildingId, buildingName:buildingName, propertyName:propertyFee.propertyName,period:period}}">{{ propertyFee.propertyName }}</router-link>
							</div>
						</strong>
					</td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key2 + 1)}" class="clickable-column" style="text-align:center"  v-for="fee, key2 in propertyFee.fees">
                        <div v-if="key2 > 11">
                            <strong>
                                <div v-if="fee == 0">

                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
                            </strong>
                        </div>
                        <div v-else>
                            <div v-if="fee == 0">

                            </div>
                            <div v-else>
                                <router-link :to="{name:'payments', params: { propertyId:propertyFee.propertyId, buildingId:buildingId, buildingName:buildingName, propertyName:propertyFee.propertyName,month:key2+1,year:yearCalculated}}">{{ $filters.toCurrency(fee) }}</router-link>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
					<td scope="row">
						<strong> 
							 Total 
						</strong>
					</td>
                   <td v-bind:class="{'active-month-column': currentMonth == (key3 +1)}" style="text-align:center"  v-for="(total,key3) in totalFees"> 
						<strong> 
							<div v-if="total == 0">
                                
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(total) }}
                            </div> 
						</strong> 
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { authenticationService } from "@/_services";
export default {
  props: ["buildingId", "route", "period", "filter", "dark"],
  data: function () {
    return {
      propertyFees: [],
      totalFees: [],
      index: 0,
      isModalVisible: true,
      propertyId: 0,
      monthParam: 0,
        currentUser: null,
      currentMonth:0
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },

  mounted() {
      if (this.buildingId) this.fetchStatement();
      if (!this.$period.isCurrent(this.period)) {
          this.currentMonth = 12;
          this.year = new Date().getFullYear() - Number(this.period);
      } else {
          this.year = new Date().getFullYear() - 1;
          this.currentMonth = new Date().getMonth() + 1;
      }
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    beforeOpen(event) {
      this.propertyId = event.params.creditortypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    /*fetchStatement: function(){
							this.mute = true;
							var request = '/admin/statment/collected/get/';
							if(this.route =="home")
								request = '/home/statment/collected/get/';
							
							request = request+this.buildingId;
                            request = request + '/' + (this.period == null ? 1 : this.period);
                            window.axios.get(request).then(({data}) => {
                                    
                                this.mute = false;
                                this.propertyFees = JSON.parse(data.propertyFees);
                                this.totalFees = data.totalFees;
					});
					
                    },*/

    fetchStatement: function () {
      this.mute = true;
      var request = "/statement/collected";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      if (this.currentUser.role === "Owner")
        request =
          request +
          "/owner?id=" +
          this.buildingId +
          "&userid=" +
          this.currentUser.id +
          "&period=" +
          this.period;
      else
        request = request + "?id=" + this.buildingId + "&period=" + this.period;
      /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/

      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.propertyFees = data.propertyFees;
          this.totalFees = data.totalFees;
        });
    },
    openBuilding(propertyFee) {
      this.$router.push({
        name: "controlpanel",
        params: {
          buildingId: propertyFee.propertyId,
          buildingName: propertyFee.propertyName,
        },
      });
      //
      location.reload();
    },
    showModalTemp: function (propertyId, month) {
      //this.$modal.show('creditors-form', { 'creditortypeid': creditorId,  'month' : month});
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      // this.$modal.show('creditors-form');
    },
    hide() {
      // this.$modal.hide('creditors-form');
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    yearCalculated() {
      return new Date().getFullYear() - (this.$period.yearsBack(this.period));
    },
    getProperties() {
      var propertyFees = this.propertyFees.filter((propertyFee) => {
        if (this.filter)
          return propertyFee.propertyName
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        else return this.propertyFees;
      });

      return propertyFees;
    },
    total: function () {
      return this.propertyFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>
